module.exports = __webpack_public_path__ + "static/media/medal-bronze-v2.3bf20984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResultHeader/assets/medals/medal-bronze-v2.svg
// module id = 1220
// module chunks = 0